import React, { useEffect } from "react";

const useGetHeightPage = (extraHeight = 0) => {
  const [height, setHeight] = React.useState(0);

  useEffect(() => {
    const pageContent = document.body.querySelector(".page-content");

    const sendHeight = () => {
      const h = (pageContent?.offsetHeight || 0) + extraHeight;

      if (h) {
        window.parent.postMessage({ iframeHeight: h }, "*");
        setHeight(h);
      }
    };

    const timer = setTimeout(sendHeight, 1000);
    window.addEventListener("load", sendHeight);

    let observer;
    if (pageContent && typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(sendHeight);
      observer.observe(pageContent);
    }

    return () => {
      clearTimeout(timer);
      window.removeEventListener("load", sendHeight);
      if (observer) observer.disconnect();
    };
  }, []);

  return height;
};

export default useGetHeightPage;
